import { NetworkBasePopUp } from '../../NetworkBasePopUp';
import {
  GoldenImageAssignation,
  GzGoldenImageAssignationWebComponent,
} from '../component/GzGoldenImageAssignationWebComponent';
import { translateFn } from '../../../../../utils/translator.helper';
import { GzDialog } from '../../../../../ui/gzDialog/component/GzDialog';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ConsoleRequest, DataProviderType } from '../../../../../utils/request';

export const AFTER_UNMARK_EVENT_NAME = 'afterUnmarkGoldenImage';

export class UnmarkGoldenImagePopUp extends NetworkBasePopUp<GzGoldenImageAssignationWebComponent> {
  protected customEventNameAfterConfirm = AFTER_UNMARK_EVENT_NAME;
  protected title = translateFn('Unmark as Golden Image');
  protected extraDialogConfigs: Partial<GzDialog> = { isWindow: false };

  protected customSetup() {
    const target = this.getSelectedTarget();
    if (!target) {
      return;
    }

    this.popUpContent = new GzGoldenImageAssignationWebComponent();
    this.popUpContent.type = GoldenImageAssignation.UNASSIGN;
  }

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    const target = this.getSelectedTarget();
    if (!target) {
      return;
    }

    const payload = {
      protectedEntityId: target._id,
    };

    try {
      await ConsoleRequest.createRequest({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'UnifiedEndpoints',
        method: 'unmarkAsGoldenImage',
        payload: payload,
      });

      this.showCustomToast(translateFn('Endpoint successfully unmarked as a Golden Image.'));
    } catch (e) {
      this.showErrorToastNotification(translateFn('Failed to unmark the endpoint as a Golden Image.'));
    }
  }

  private getSelectedTarget(): ProtectedEntity | undefined {
    if (!this.data.targets || this.data.targets.length !== 1) {
      console.error('Could not open dialog. Targets are not defined or received multiple targets.');
      return undefined;
    }

    return this.data.targets[0];
  }
}
